export default {"src":"/_next/static/media/Bank-tatement-hero-bg.23a28d58.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};